import ConventionalPcrGradientCalculator from './ConventionalPcrGradientCalculator';

export default ConventionalPcrGradientCalculator;
